import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Construction } from 'lucide-react';

export default function PlaceholderPage() {
  const location = useLocation();
  const pageName = location.pathname.split('/').pop().replace(/-/g, ' ');

  return (
    <div className="space-y-6 animate-fade-in-up" data-testid="placeholder-page">
      <div>
        <h1 className="font-heading text-3xl font-medium tracking-tight text-foreground capitalize">
          {pageName}
        </h1>
        <p className="text-muted-foreground mt-1">
          This feature is under development
        </p>
      </div>

      <Card className="border-border shadow-sm">
        <CardContent className="flex flex-col items-center justify-center py-16">
          <div className="p-4 rounded-full bg-muted mb-4">
            <Construction className="w-8 h-8 text-muted-foreground" />
          </div>
          <CardTitle className="font-heading text-lg">Coming Soon</CardTitle>
          <CardDescription className="text-center mt-2 max-w-md">
            This module is currently in development and will be available in future updates.
            The architecture supports seamless integration with AI transcription, 
            AI-assisted prescriptions, and video consultations.
          </CardDescription>
        </CardContent>
      </Card>
    </div>
  );
}
